module.exports = __webpack_public_path__ + "media/images/edit_ic-804ec1b660f11c87d3f4d29bb24ecc98.svg";